module.exports = __webpack_public_path__ + "img/drag-n-drop.4dfaf233.png";